import cc from 'classcat';
import { isMobile } from 'utils/is-mobile';
import { Skeleton } from 'newcomponents/UI/Skeleton';

type TLivePrematchTabsSkeletonProps = {
  fullWidth?: boolean;
  activeItem: number | string;
  className?: string;
};

export const LivePrematchTabsSkeleton = ({
  fullWidth,
  className,
  activeItem
}: TLivePrematchTabsSkeletonProps) => {
  return (
    <div
      className={cc([
        `customMenu__wrapper ${className || ''}`,
        {
          'customMenu__wrapper--mobile': isMobile(),
          'customMenu__wrapper--desktop': !isMobile(),
          'customMenu__wrapper--fullWidth': fullWidth
        }
      ])}
    >
      <div className="customMenu">
        <div
          className={cc([
            'customMenu__item',
            {
              'customMenu__item--mobile': isMobile(),
              'customMenu__item--active': activeItem === 0
            }
          ])}
        >
          <Skeleton
            className="customMenu__skeleton"
            title={{ width: '50px' }}
            paragraph={false}
            active
          />
        </div>
        <div
          className={cc([
            'customMenu__item',
            {
              'customMenu__item--mobile': isMobile(),
              'customMenu__item--active': activeItem === 1
            }
          ])}
        >
          <Skeleton
            className="customMenu__skeleton"
            title={{ width: '50px' }}
            paragraph={false}
            active
          />
        </div>
      </div>
    </div>
  );
};
